/* eslint-disable prefer-const */
import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  // NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { CommonPagesService } from 'src/@shared/shared/common-pages.service';
import { responseMessageStatus, ResponseStatus } from 'src/@shared/shared/enum';
import { ProgramPeriod } from 'src/models/programPeriod.model';
import { InnerPagesService } from '../inner-pages.service';
import { AuthGuard } from 'src/@shared/shared/auth.guard';
import { AccountSection } from '../account-settings/shared/account-sidebar.component';
import { MfaChallengeStore, isPhoneVerificationRequired, isMfaPending, DeviceIdService, PhoneVerificationStore } from 'src/@shared/auth';
declare const jQuery: any;
@Component({
  selector: 'app-common-layout',
  templateUrl: './common-layout.component.html',
  styleUrls: ['./common-layout.component.scss', '../account-settings/account-layout.scss'],
  standalone: false
})
export class CommonLayoutComponent implements OnInit {
  //#region properties
  currentUrl: string;
  isVisivleChangePassword: boolean = false;
  isVisibleSwitchAccountModal: boolean = false;
  canViewSummary: boolean = false;
  canViewActivity: boolean = false;
  canViewInvestments: boolean = false;
  canAddPayment: boolean = false;
  canViewInvestors: boolean = false;
  canViewVendors: boolean = false;
  canViewProgramsTags: boolean = false;
  canViewUsers: boolean = false;
  canViewNotifications: boolean = false;
  canViewTutorials: boolean = false;
  canViewReports: boolean = false;
  supplierId: string;
  settingUrl: string = '';
  hasSettingsPage: boolean = false;
  userInfo = JSON.parse(localStorage.getItem('UserInfo') || '{}');
  userRoleDetails = JSON.parse(localStorage.getItem('UserRoleDetails') || '{}');
  bearerToken = localStorage.getItem('BearerToken');
  agencyDetails: any;
  supplierDetails: any;
  siteLogo: string;
  isVisibleAnnouncements: boolean = false;
  siteName: string = '';
  listOfPrograms: ProgramPeriod[] = [];
  listOfTags: any[] = [];
  subscriptions: Subscription[] = [];
  notificationsCount: number = 0;
  numberOfSeconds: number = 5;
  isVisibleMenu: boolean = false;
  sessionAgencyDetails = JSON.parse(
    sessionStorage.getItem('AgencyDetails') || '{}'
  );
  listOfAllocatedSites = JSON.parse(
    localStorage.getItem('AllocatedSites') || '[]'
  );
  currentYear: any = new Date().getFullYear();
  canViewPrograms: boolean = false;
  previousUrl: string = '';
  accountsCount: number = localStorage.getItem('listOfAccounts')
    ? Number(JSON.parse(localStorage.getItem('listOfAccounts') || '0'))
    : 0;
  sitesCount: number = localStorage.getItem('listOfAccounts')
    ? Number(JSON.parse(localStorage.getItem('listOfAccounts') || '0'))
    : 0;
  supplierCount: number = localStorage.getItem('listOfSuppliers')
    ? Number(JSON.parse(localStorage.getItem('listOfSuppliers') || '0'))
    : 0;
  supplierBankSitesCount: number = localStorage.getItem('listOfSupplierBanks')
    ? Number(JSON.parse(localStorage.getItem('listOfSupplierBanks') || '0'))
    : 0;
  listOfAccounts: any[];
  listOfSuppliers: any[];
  listOfSupplierBanks: any[];
  listOfSites: any[];
  listOfSBSites: any[];
  //#endregion

  /** Header logo target: the first page this role can open (usually Summary). */
  homeUrl = '';

  //#region constructor
  constructor(
    public _cS: CommonService,
    private _router: Router,
    private _iS: InnerPagesService,
    private route: ActivatedRoute,
    private _cpS: CommonPagesService,
    private authGuard: AuthGuard,
    private deviceId: DeviceIdService,
    private mfaChallengeStore: MfaChallengeStore,
    private phoneVerificationStore: PhoneVerificationStore
  ) {
    this.supplierId = this.route.snapshot.paramMap.get('supplierId');
    if (this.userInfo) {
      this._cS.on('NewAnnouncement', (notifications: any) => {
        if (notifications) {
          const currentUser = notifications.find(
            (x: any) => x.userId == this.userInfo.userId
          );
          const totalAnouncements = currentUser.announcements;
          const toShowNotificatioons = totalAnouncements.find(
            (x: any) => x.siteId == this.supplierId
          );
          this.notificationsCount = toShowNotificatioons.count;
        }
      });
    }
    const authenticateUser = window.location.href.split('?t=')[1];
    if (authenticateUser && this.bearerToken == null) {
      this.currentUrl = this._router.url;
      this.route.queryParams.subscribe((params) => {
        if (params) {
          let email = params['e'];
          let rToken = params['t'];
          let paybevToken = params['pt'];
          if (paybevToken) {
            localStorage.setItem('PaybevBearerToken', paybevToken);
          }
          if (email && rToken) {
            email = email.replace('=', '');
            rToken = rToken.replace('=', '');
            const formData = new FormData();
            formData.set('email', email);
            formData.set('token', rToken);
            formData.set('environment', 'SUPPLIER');
            formData.set('deviceFingerprint', this.deviceId.getOrCreate());
            this._cS.paybevAutoLogin(formData).subscribe((response: any) => {
              const ssoResult = response?.result;
              if (response.responseStatus == ResponseStatus.success && ssoResult && isMfaPending(ssoResult)) {
                // New portal on a device it has not seen: second factor first, then verify-user lands the user.
                this.mfaChallengeStore.set({
                  challengeId: ssoResult.challengeId,
                  email: decodeURIComponent(escape(atob(email))),
                  channels: ssoResult.channels,
                  maskedPhone: ssoResult.maskedPhone,
                  maskedEmail: ssoResult.maskedEmail,
                  sent: ssoResult.sent,
                  sendMessage: ssoResult.sendMessage,
                });
                this._router.navigate(['/verify-user']);
                return;
              }
              if (response.responseStatus == ResponseStatus.success && ssoResult && isPhoneVerificationRequired(ssoResult)) {
                this.phoneVerificationStore.set(ssoResult);
                this._router.navigate(['/mobile-verify']);
                return;
              }
              if (response.responseStatus != ResponseStatus.success) {
                this._cS.displayMessage(responseMessageStatus.error, response.message || 'Sign-in handoff failed. Please sign in.');
                this._router.navigate(['/login']);
                return;
              }
              if (response.responseStatus == ResponseStatus.success) {
                const usersDetails = response.result.userdetails;
                const userInfo = {
                  firstName: usersDetails.firstName,
                  lastName: usersDetails.lastName,
                  userId: usersDetails.id,
                  phoneNumber: usersDetails.phoneNumber,
                  agency: usersDetails.agency,
                  twoFactorEnabled: usersDetails.twoFactorEnabled,
                  isForcePasswordChange: usersDetails.isForcePasswordChange,
                  email: usersDetails.email,
                  localSupplier: usersDetails.localSupplier,
                  suppliers: usersDetails.suppliers,
                  supplierBankSitesData: response.result.supplierBank
                };
                _cS.userInfoHeader.next(userInfo);
                localStorage.setItem(
                  'BearerToken',
                  response.result.access_token
                );
                localStorage.setItem(
                  'RefreshToken',
                  response.result.refreshToken
                );
                localStorage.setItem(
                  'UserRole',
                  response.result.userRoleDetails.name
                );
                localStorage.setItem(
                  'UserRoleDetails', JSON.stringify(response.result.userRoleDetails)
                );
                localStorage.setItem('UserInfo', JSON.stringify(userInfo));
                this.userInfo = JSON.parse(JSON.stringify(userInfo));

                const SupplierModulesPermissions =
                  response.result.userRoleDetails.permissions.filter(
                    (x: any) => x.moduleType == 'Supplier'
                  );

                const PaybevModulesPermissions =
                  response.result.userRoleDetails.permissions.filter(
                    (x: any) => x.moduleType == 'Paybev'
                  );

                this.listOfAccounts = [...response.result?.operator || []];
                this.listOfSuppliers = [...usersDetails?.suppliers || []];
                this.listOfSupplierBanks = [...response.result?.supplierBank || []];

                this.listOfSites = this.listOfAccounts.flatMap((account: any) => account.Sites || []);
                //fetch sites from all supplierBank accounts
                const supplierBankSites = this.listOfSupplierBanks.flatMap((account: any) => account.Sites || []);
                //merge sites from operator accounts and supplierBank accounts
                this.listOfSBSites = supplierBankSites;

                this.supplierCount = usersDetails.suppliers?.length || 0;
                this.sitesCount = this.listOfSites?.length || 0;
                this.supplierBankSitesCount = this.listOfSBSites?.length || 0;


                localStorage.setItem('listOfAccounts', JSON.stringify(this.listOfSites?.length || 0));
                localStorage.setItem('listOfSuppliers', JSON.stringify(usersDetails.suppliers?.length || 0));
                localStorage.setItem('listOfSupplierBanks', JSON.stringify(this.listOfSBSites?.length || 0));

                localStorage.setItem(
                  'RolePermissions',
                  JSON.stringify(SupplierModulesPermissions)
                );
                localStorage.setItem(
                  'SupplierRolePermissions',
                  JSON.stringify(SupplierModulesPermissions)
                );
                localStorage.setItem(
                  'PaybevRolePermissions',
                  JSON.stringify(PaybevModulesPermissions)
                );
                localStorage.setItem('IsSiteSelected', JSON.stringify(true));

                this.checkPermissions();
                this.getSiteAgencyDetails();
                this._cS.updateSiteDetails.next('call');
                this._router.navigate([], {
                  queryParams: {
                    t: null,
                    e: null,
                  },
                  queryParamsHandling: 'merge',
                });
              }
            });
          }
        }
      });
    } else {
      this.checkPermissions();
      this._cS.updateSiteDetails.next('call');
    }
  }
  //#endregion
  //#region functions
  /** User Profile + Security screens: full-bleed content so the mint panel can match the sider height. */
  get isAccountSettingsView(): boolean {
    const url = this.currentUrl || '';
    return url.includes('/user-profile/') || url.includes('/security/');
  }

  /** Which account menu the mobile drawer shows on the User Profile / Security screens. */
  get accountSection(): AccountSection {
    return (this.currentUrl || '').includes('/security/') ? 'security' : 'profile';
  }

  ngOnInit(): void {
    //get current site details and update site accordingly
    this.supplierId = this.route.snapshot.paramMap.get('supplierId');

    this.setAgencyColorLogo();

    this.currentUrl = this._router.url;
    this.previousUrl = null;

    // Listen to router events to track navigation
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Update previous URL and set current URL to the new one
        this.previousUrl = this._cS.previousURL = this.currentUrl;
        this.currentUrl = this._cS.currentURL = event.url;
        sessionStorage.setItem('previousURL', this.previousUrl);
        sessionStorage.setItem('currentURL', this.currentUrl);
      }
    });
    this.subscriptions.push(
      this._cS.userInfoHeader.subscribe((res: any) => {
        if (res) {
          this.userInfo.firstName = res.firstName;
          this.userInfo.lastName = res.lastName;
          this.userInfo.phoneNumber = res.phoneNumber;
        }
      }),
      this._cS.updateSiteDetails.subscribe((res: any) => {
        if (res) {
          this.getSiteAgencyDetails();
          // this.getAnnouncements();
        }
      })
    );
    // setTimeout(() => {
    //   this.getAnnouncements();
    // }, 1000);
  }
  logout() {
    // Remove query params
    this._router.navigate([], {
      queryParams: {
        t: null,
        e: null,
      },
      queryParamsHandling: 'merge',
    });
    this._cS.hubConnection.stop();
    // Sign out locally whether or not the API call succeeds; a failed revoke must never keep the user signed in.
    this._iS.logOut().subscribe({
      next: () => this._cS.logOut(),
      error: () => this._cS.logOut(),
    });
  }
  getAnnouncements() {
    this._iS.getAnnouncements(this.supplierId).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.notificationsCount = response.result?.length;
      } else {
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }

  //load program periods
  loadPrograms() {
    this._cS.isLoadingPrograms = true;
    this._cpS.getProgramBySite().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfPrograms = response.result;
        this._cS.listOfProgramPeriods.next(this.listOfPrograms);
        this._cS.isLoadingPrograms = false;
      } else {
        this.listOfPrograms = [];
        this._cS.displayMessage(responseMessageStatus.error, response.message);
        this._cS.isLoadingPrograms = false;
      }
    });
  }
  checkPermissions() {
    this.canViewSummary = this._iS.canAccessSummary().canViewSummary;
    this.canViewActivity = this._iS.canAccessActivity().canViewActivity;
    this.canViewInvestments =
      this._iS.canAccessInvestments().canViewInvestments;
    this.canViewPrograms = this._iS.canAccessPrograms().canViewPrograms;
    // this.canAddPayment = this._iS.canAccessPayments().canAddPayment;
    // this.canViewInvestors = this._iS.canAccessInvestors().canViewInvestors;
    // this.canViewVendors = this._iS.canAccessVendors().canViewVendors;
    // this.canViewProgramsTags =
    //   this._iS.canAccessProgramsTags().canViewProgramsTags;
    this.canViewUsers = this._iS.canAccessUsers().canViewUsers;
    this.canViewNotifications =
      this._iS.canAccessNotifications().canViewNotifications;
    this.canViewTutorials = this._iS.canAccessTutorials();
    this.canViewReports = this._iS.canAccessReports();

    const allowedPages = [
      { permission: this.canViewUsers, url: '/users' },
      { permission: this.canViewNotifications, url: '/notifications' },
      { permission: this.canViewTutorials, url: '/tutorials' },
    ];

    //find the first record from allowed pages which has permission set to true and extract its url
    const allowedPage = allowedPages.find((obj) => obj.permission == true);
    this.hasSettingsPage = !!allowedPage;
    if (allowedPage) {
      this.settingUrl = '/supplier/' + this.supplierId + allowedPage.url;
    } else {
      this.settingUrl = '/supplier/' + this.supplierId + '/users';
    }
    this.homeUrl = this.authGuard.getLandingUrl('/supplier/' + this.supplierId);
  }
  getSiteAgencyDetails() {
    this._iS
      .getSiteAgencyDetails(this.supplierId)
      .subscribe((response: any) => {
        if (response) {
          if (response.responseStatus == ResponseStatus.success) {
            this.agencyDetails = response.result.agencyDetails;
            this.supplierDetails = response.result.supplierDetails;
            this.siteName = this._iS.siteName =
              this.supplierDetails.investorDisplayName;
            // if((!this.siteDetails.IsProgramPeriodVisible && this.currentUrl.includes('program-periods')) || (!this.siteDetails.IsTagVisible && this.currentUrl.includes('tags'))){
            //   this._router.navigate(['page-not-found'])
            //  }
            this._cS.agencySiteDetails.next(this.supplierDetails);
            sessionStorage.setItem(
              'AgencyDetails',
              JSON.stringify(this.agencyDetails)
            );
            sessionStorage.setItem(
              'SupplierDetails',
              JSON.stringify(this.supplierDetails)
            );
            sessionStorage.setItem('CurrentSite', this.supplierDetails._id);
            this.sessionAgencyDetails = this.agencyDetails;
            this.setAgencyColorLogo();
            this._cS.fetchDataAfterAutoLogin.next(true);
          } else {
            this._cS.displayMessage(
              responseMessageStatus.error,
              response.message
            );
          }
        } else {
          this._cS.redirectToSwitchAccount();
        }
      });
  }
  getTags() {
    this._cS.isLoadingTags = true;
    setTimeout(() => {
      this._iS
        .getTagsDropdownList(this.supplierId)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.listOfTags = response.result;
            this._cS.listOfTags.next(this.listOfTags);
            this._cS.isLoadingTags = false;
          } else {
            this.listOfTags = [];
            this._cS.isLoadingTags = false;
          }
        });
    }, 1000);
  }

  showAnnouncemnts() {
    this.isVisibleAnnouncements = true;
  }

  setAgencyColorLogo() {
    if (this.sessionAgencyDetails?.DarkColor) {
      document.documentElement.style.setProperty(
        '--theme-color',
        this.sessionAgencyDetails?.DarkColor
      );
    }
    document.documentElement.style.setProperty(
      '--light-color',
      this.sessionAgencyDetails?.LightColor
    );
    this.siteLogo = this.sessionAgencyDetails?.Profile;
  }

  showSwitchAccountModal() {
    this.isVisibleSwitchAccountModal = true;
  }
  hideSwitchAccountModal() {
    this.isVisibleSwitchAccountModal = false;
  }
  openChangePasswordModal() {
    this.isVisivleChangePassword = true;
  }
  hideChangePassword(event: any) {
    this.isVisivleChangePassword = event.hide;
  }
  hideAnnouncements(event: any) {
    this.isVisibleAnnouncements = event.visible;
    this.notificationsCount = event.notifications;
  }
  handleCancelisVisibleMenu() {
    this.isVisibleMenu = false;
  }
  removeClass() {
    jQuery('body').removeClass('active-menu');
  }
  ngOnDestroy(): void {
    this.subscriptions.map((s) => s.unsubscribe());
  }
  //#endregion
}
